import React from 'react'
import { Chip, type ChipProps } from '@mui/material'
import { isEmpty } from 'lodash'
import { SlotStatus } from '../../../../models/DistributionPlan'

interface CellBadgeProps extends ChipProps {
  label?: string
  disabled?: boolean
  onClick?: () => void
}

const getChipType = (status: string | undefined): { color: string, variant: string } => {
  switch (status) {
    case SlotStatus.Draft:
    case SlotStatus.Closed:
      return { color: 'default', variant: 'outlined' }
    case SlotStatus.Published:
      return { color: 'primary', variant: 'filled' }
    case SlotStatus.Live:
      return { color: 'success', variant: 'filled' }
    default:
      return { color: 'primary', variant: 'outlined' }
  }
}

const CellBadge: React.FC<CellBadgeProps> = ({
  label,
  onClick,
  disabled = false,
  ...props
}) => {
  if (isEmpty(label)) {
    return null
  }

  const { color, variant } = getChipType(label)

  return (
    <Chip
      label={label}
      onClick={onClick}
      disabled={disabled}
      size='small'
      color={color as CellBadgeProps['color']}
      variant={variant as CellBadgeProps['variant']}
      {...props}
    />
  )
}

export default CellBadge
